export default "__VITE_ASSET__m5hdGB_c__"